import Translations from './translation'
import defaults from 'lodash/defaults';
import i18next from "../../i18n";

const getVariableDictionary = (variables) => {
    let dict = {};
    for (let i = 1 ; i <= variables.length; i++) {
        let key = "VAR" + i;
        dict[key] = variables[i - 1];
    }
    return dict;
}

const localize = function (lang, key, variables) {
    if (!key) {
        throw 'Translations: Missing key';
    }

    if (!lang) {
        lang = Translations.getCurrentLanguage().name;
        if (!lang) {
            throw 'Translations: Missing language';
        }
    }

    if (variables && variables.length !== 0) {
        const dict =   getVariableDictionary(variables);
        return i18next.t(key, dict);
    }

    return i18next.t(key);


};

const localized = (lang) => function (params) { return localize.call(this, lang, params); }

const getLength = (value, options) => {
    if (isNaN(value)) {
        console.log("Provided length value is not a number");
        return value;
    }

    const {valueMeasurementSystem, targetMeasurementSystem, round, format} = defaults(options, {
        valueMeasurementSystem: "metric",
        targetMeasurementSystem: Translations.getMeasurementSystem(),
        round: null,
        format: null,
    });

    const convertToMiles = () => valueMeasurementSystem === "metric" ? value / 1.609 : value;
    const convertToKilometers = () => valueMeasurementSystem === "metric" ? value : 1.609 * value;

    let targetValue = targetMeasurementSystem === "metric" ? convertToKilometers() : convertToMiles();

    if (round) {
        targetValue = round(targetValue);
    }

    if (format) {
        targetValue = format(targetValue)
    }

    return targetValue;
}
export { localize, localized, getLength }
